// 全て遅延ロードさせているが、それだけの意味があるのかどうか微妙。
// 遅延ローディングしたいというよりも、 import 文と component: 部分を分けたくないという理由のほうが強い。
// 何れにせよローディング画面は入れたほうがいい気がする。
//
// フロントのルータは当然（？）フロントエンド側（つまりユーザーがコードを改ざん可能な側）に設置されるので、
// ここできちんとした認証を行なうことは不可能。要するに、ここにルートを置いたからと言って安全なわけではない。
// ちゃんとした認証（とそれが必要なAPI）は全面的にバックエンド側で行なう。

export default [
  {
    path: "/",
    component: () => import("@/components/RootComponent"),
    name: "RootComponent"
  },
  {
    path: "/login",
    component: () => import("@/components/LoginComponent"),
    name: "LoginComponent"
  },
  {
    path: "/about",
    component: () => import("@/components/AboutComponent"),
    name: "AboutComponent"
  },
  // ここからマイページ
  {
    path: "/mypage",
    component: () => import("@/components/mypage/MypageRoot"),
    name: "MypageRoot",
    meta: { auth: { member: [true], sitter: [true] } }
  },
  {
    path: "/mypage/members",
    component: () => import("@/components/mypage/members/MypageMembersRoot"),
    name: "MypageMembersRoot",
    meta: { auth: { member: [true] } }
  },
  {
    path: "/mypage/members/profile",
    component: () => import("@/components/mypage/members/MypageMembersProfile"),
    name: "MypageMembersProfile",
    meta: { auth: { member: [true] } }
  },
  {
    path: "/mypage/members/kids",
    // クエリは idx
    component: () => import("@/components/mypage/members/MypageMembersKids"),
    name: "MypageMembersKids",
    meta: { auth: { member: [true] } }
  },
  {
    path: "/mypage/members/emergencies",
    component: () =>
      import("@/components/mypage/members/MypageMembersEmergencies"),
    name: "MypageMembersEmergencies",
    meta: { auth: { member: [true] } }
  },
  {
    path: "/mypage/members/requests",
    component: () =>
      import("@/components/mypage/members/MypageMembersRequests"),
    name: "MypageMembersRequests",
    meta: { auth: { member: [3] } }
  },
  {
    path: "/mypage/members/messages",
    component: () =>
      import("@/components/mypage/members/MypageMembersMessages"),
    name: "MypageMembersMessages",
    meta: { auth: { member: [3] } }
  },
  {
    path: "/mypage/members/messages/threads",
    component: () =>
      import("@/components/mypage/members/MypageMembersMessagesThreads"),
    name: "MypageMembersMessagesThreads",
    meta: { auth: { member: [3] } }
  },
  {
    path: "/requests/sitter-wanted-list",
    component: () =>
      import("@/components/RequestsSitterWantedList"),
    name: "RequestsSitterWantedList"
  },
  {
    path: "/requests/sitter-wanted",
    component: () =>
      import("@/components/RequestsSitterWanted"),
    name: "RequestsSitterWanted",
    meta: { auth: { member: [3] } }
  },
  {
    path: "/requests/sitter-apply",
    component: () =>
      import("@/components/RequestsSitterApply"),
    name: "RequestsSitterApply",
    meta: { auth: { sitter: [3] } }
  },
  {
    path: "/mypage/sitters",
    component: () => import("@/components/mypage/sitters/MypageSittersRoot"),
    name: "MypageSittersRoot",
    meta: { auth: { sitter: [3] } }
  },
  {
    path: "/mypage/sitters/schedules",
    component: () =>
      import("@/components/mypage/sitters/MypageSittersSchedules"),
    name: "MypageSittersSchedules",
    meta: { auth: { sitter: [3] } }
  },
  {
    path: "/mypage/sitters/monthly-schedules",
    component: () =>
      import("@/components/mypage/sitters/MypageSittersMonthlySchedules"),
    name: "MypageSittersMonthlySchedules",
    meta: { auth: { sitter: [3] } }
  },
  {
    path: "/mypage/sitters/requests",
    component: () =>
      import("@/components/mypage/sitters/MypageSittersRequests"),
    name: "MypageSittersRequests",
    meta: { auth: { sitter: [3] } }
  },
  {
    path: "/mypage/sitters/messages/threads",
    component: () =>
      import("@/components/mypage/sitters/MypageSittersMessagesThreads"),
    name: "MypageSittersMessagesThreads",
    meta: { auth: { sitter: [3] } }
  },
  {
    path: "/mypage/sitters/messages",
    component: () =>
      import("@/components/mypage/sitters/MypageSittersMessages"),
    name: "MypageSittersMessages",
    meta: { auth: { sitter: [3] } }
  },
  {
    path: "/mypage/sitters/profile",
    component: () => import("@/components/mypage/sitters/MypageSittersProfile"),
    name: "MypageSittersProfile",
    meta: { auth: { sitter: [3] } }
  },
  {
    path: "/mypage/sitters/qualifications",
    component: () => import("@/components/mypage/sitters/MypageSittersQualifications"),
    name: "MypageSittersQualifications",
    meta: { auth: { sitter: [3] } }
  },
  {
    path: "/mypage/sitters/public-relations",
    component: () => import("@/components/mypage/sitters/MypageSittersPublicRelations"),
    name: "MypageSittersPublicRelations",
    meta: { auth: { sitter: [3] } }
  },  
  {
    path: "/mypage/sitters/support-settings",
    component: () => import("@/components/mypage/sitters/MypageSittersSupportSettings"),
    name: "MypageSittersSupportSettings",
    meta: { auth: { sitter: [3] } }
  },  
  {
    path: "/mypage/sitters/rehabilitation-places",
    component: () => import("@/components/mypage/sitters/MypageSittersRehabilitationPlaces"),
    name: "MypageSittersRehabilitationPlaces",
    meta: { auth: { sitter: [3] } }
  },
  // ここまでマイページ
  {
    path: "/members/register",
    component: () => import("@/components/MembersRegister"),
    name: "MembersRegister"
  },
  {
    path: "/members/register_sent",
    component: () => import("@/components/MembersRegisterSent"),
    name: "MembersRegisterSent"
  },
  {
    path: "/members/confirm",
    component: () => import("@/components/MembersConfirm"),
    name: "MembersConfirm"
  },
  {
    path: "/members/flow",
    component: () => import("@/components/MembersFlow"),
    name: "MembersFlow"
  },
  {
    path: "/members/registration-flow",
    component: () => import("@/components/MembersRegistrationFlow"),
    name: "MembersRegistrationFlow"
  },
  {
    path: "/sitters/register",
    component: () => import("@/components/SittersRegister"),
    name: "SittersRegister"
  },
  {
    path: "/sitters/register-sent",
    component: () => import("@/components/SittersRegisterSent"),
    name: "SittersRegisterSent"
  },
  {
    path: "/sitters/confirm",
    component: () => import("@/components/SittersConfirm"),
    name: "SittersConfirm"
  },
  {
    path: "/sitters/register-flow-1",
    component: () => import("@/components/SittersRegisterFlow1"),
    name: "SittersRegisterFlow1",
    // エンティティ定義書のステータス定義を参照。メンバーの場合は
    // 0: 無効、 1: 審査中、 2: 審査NG、 3: 審査OK、 9: 論理削除
    // らしい。
    // 例えばこの場合、ステータスが 1, 2, 3 のいずれかであればOKになる。
    // role と privilege モデルにしたほうがいいとは思うが…。
    // TODO: 全体的に、サポーターのステータスの考慮や、全てOKの true みたいなのを導入する。
    meta: { auth: { sitter: [1] } }
  },
  {
    path: "/sitters/register-flow-2",
    component: () => import("@/components/SittersRegisterFlow2"),
    name: "SittersRegisterFlow2",
    meta: { auth: { sitter: [1] } }
  },
  {
    path: "/sitters/register-flow-3",
    component: () => import("@/components/SittersRegisterFlow3"),
    name: "SittersRegisterFlow3",
    meta: { auth: { sitter: [1] } }
  },
  {
    path: "/sitters/register-flow-4",
    component: () => import("@/components/SittersRegisterFlow4"),
    name: "SittersRegisterFlow4",
    meta: { auth: { sitter: [1] } }
  },
  {
    path: "/sitters/register-flow-5",
    component: () => import("@/components/SittersRegisterFlow5"),
    name: "SittersRegisterFlow5",
    meta: { auth: { sitter: [1] } }
  },
  {
    path: "/sitters/register-flow-6",
    component: () => import("@/components/SittersRegisterFlow6"),
    name: "SittersRegisterFlow6",
    meta: { auth: { sitter: [1] } }
  },
  {
    path: "/sitters/recruitment",
    component: () => import("@/components/SittersRecruitment"),
    name: "SittersRecruitment"
  },
  {
    path: "/sitters/search",
    component: () => import("@/components/SittersSearch"),
    name: "SittersSearch"
  },
  {
    path: "/sitters/details/:id",
    component: () => import("@/components/SittersDetails"),
    name: "SittersDetails"
  },
  // オンライン面談申込
  {
    path: "/sitters/interview-offer",
    component: () => import("@/components/SittersInterviewOffer"),
    name: "SittersInterviewOffer",
    meta: { auth: { sitter: [1] } }
  },
  // オンライン面談申込完了
  {
    path: "/sitters/interview-offer-completed",
    component: () => import("@/components/SittersInterviewOfferCompleted"),
    name: "SittersInterviewOfferCompleted",
    meta: { auth: { sitter: [1] } }
  },
  {
    path: "/price",
    component: () => import("@/components/PriceComponent"),
    name: "PriceComponent"
  },
  {
    path: "/tos",
    component: () => import("@/components/TermsOfService"),
    name: "TermsOfService"
  },
  {
    path: "/company",
    component: () => import("@/components/CompanyComponent"),
    name: "CompanyComponent"
  },
  {
    path: "/sctl",
    component: () => import("@/components/SctlComponent"),
    name: "SctlComponent"
  },
  {
    path: "/faq",
    component: () => import("@/components/FaqComponent"),
    name: "FaqComponent"
  },
  {
    path: "/hogo-houshin",
    component: () => import("@/components/HogoHoushin"),
    name: "HogoHoushin"
  },
  {
    path: "/contact",
    component: () => import("@/components/ContactComponent"),
    name: "ContactComponent"
  },
  {
    path: "/contact-sent",
    component: () => import("@/components/ContactSent"),
    name: "ContactSent"
  },
  {
    path: "/if-forgot",
    component: () => import("@/components/IfForgot"),
    name: "IfForgot"
  },
  {
    path: "/password-reset",
    component: () => import("@/components/PasswordReset"),
    name: "PasswordReset"
  },
  {
    path: "/members/register-flow-1",
    component: () => import("@/components/MembersRegisterFlow1"),
    name: "MembersRegisterFlow1",
    // エンティティ定義書のステータス定義を参照。メンバーの場合は
    // 0: 無効、 1: 審査中、 2: 審査NG、 3: 審査OK、 9: 論理削除
    // らしい。
    // 例えばこの場合、ステータスが 1, 2, 3 のいずれかであればOKになる。
    // role と privilege モデルにしたほうがいいとは思うが…。
    // TODO: 全体的に、サポーターのステータスの考慮や、全てOKの true みたいなのを導入する。
    meta: { auth: { member: [true] } }
  },
  {
    path: "/members/register-flow-2",
    component: () => import("@/components/MembersRegisterFlow2"),
    name: "MembersRegisterFlow2",
    meta: { auth: { member: [true] } }
  },
  {
    path: "/members/register-flow-3",
    component: () => import("@/components/MembersRegisterFlow3"),
    name: "MembersRegisterFlow3",
    meta: { auth: { member: [true] } }
  },
  {
    path: "/members/register-flow-4",
    component: () => import("@/components/MembersRegisterFlow4"),
    name: "MembersRegisterFlow4",
    meta: { auth: { member: [true] } }
  },
  {
    path: "/members/requesting",
    // クエリは requestId
    component: () => import("@/components/MembersRequesting"),
    name: "MembersRequesting",
    meta: { auth: { sitter: [3] } }
  },
  {
    path: "/members/register-flow-5",
    component: () => import("@/components/MembersRegisterFlow5"),
    name: "MembersRegisterFlow5",
    meta: { auth: { member: [true] } }
  },
  {
    path: "/requests/create",
    component: () => import("@/components/RequestsCreate"),
    name: "RequestsCreate",
    meta: { auth: { member: [3] } }
  },
  {
    path: "/requests/sent",
    component: () => import("@/components/RequestsSent"),
    name: "RequestsSent",
    meta: { auth: { member: [3] } }
  },
  {
    path: "/requests/estimates",
    component: () => import("@/components/RequestsEstimates"),
    name: "RequestsEstimates",
    // TODO: ステータスはこれでいいのか？
    meta: { auth: { sitter: [3] } }
  },
  {
    path: "/requests/estimates/sent",
    component: () => import("@/components/RequestsEstimatesSent"),
    name: "RequestsEstimatesSent",
    // TODO: ステータスはこれでいいのか？
    meta: { auth: { sitter: [3] } }
  },
  {
    path: "/requests/estimates/confirm",
    component: () => import("@/components/RequestsEstimatesConfirm"),
    name: "RequestsEstimatesConfirm",
    meta: { auth: { member: [3] } }
  },
  {
    path: "/requests/estimates/confirmed",
    component: () => import("@/components/RequestsEstimatesConfirmed"),
    name: "RequestsEstimatesConfirmed",
    meta: { auth: { member: [3] } }
  },
  {
    path: "/requests/estimates/payment-error",
    component: () => import("@/components/RequestsEstimatesPaymentError"),
    name: "RequestsEstimatesPaymentError",
    meta: { auth: { member: [3] } }
  },
  {
    path: "/requests/reschedule",
    component: () => import("@/components/RequestsReschedule"),
    name: "RequestsReschedule",
    meta: { auth: { sitter: [3] } }
  },
  {
    path: "/requests/reschedule-confirmed",
    component: () => import("@/components/RequestsRescheduleConfirmed"),
    name: "RequestsRescheduleConfirmed",
    meta: { auth: { sitter: [3] } }
  },
  {
    path: "/requests/works",
    component: () => import("@/components/RequestsWorks"),
    name: "RequestsWorks",
    meta: { auth: { sitter: [3] } }
  },
  {
    path: "/requests/works/confirm",
    component: () => import("@/components/RequestsWorksConfirm"),
    name: "RequestsWorksConfirm",
    meta: { auth: { member: [3] } }
  },
  {
    path: "/requests/works/confirmed",
    component: () => import("@/components/RequestsWorksConfirmed"),
    name: "RequestsWorksConfirmed",
    meta: { auth: { member: [3] } }
  },
  {
    path: "/requests/payment",
    component: () => import("@/components/RequestsPayment"),
    name: "RequestsPayment",
    meta: { auth: { member: [3] } }
  },
  {
    path: "/requests/payment-completed",
    component: () => import("@/components/RequestsPaymentCompleted"),
    name: "RequestsPaymentCompleted",
    meta: { auth: { member: [3] } }
  },
  {
    path: "/requests/payment-error",
    component: () => import("@/components/RequestsPaymentError"),
    name: "RequestsPaymentError",
    meta: { auth: { member: [3] } }
  },
  {
    path: "*",
    component: () => import("@/components/NotFound")
  }
];



// WEBPACK FOOTER //
// ./src/router/routes.js